export default __webpack_public_path__ + "static/media/34I-18656_-14529_0.89500129.jpg";